// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Error_Class from "../Control.Monad.Error.Class/index.js";
import * as Control_Monad_Except from "../Control.Monad.Except/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Control_Monad_Reader from "../Control.Monad.Reader/index.js";
import * as Control_Monad_Reader_Class from "../Control.Monad.Reader.Class/index.js";
import * as Control_Monad_Reader_Trans from "../Control.Monad.Reader.Trans/index.js";
import * as Control_Monad_State_Class from "../Control.Monad.State.Class/index.js";
import * as Control_Monad_State_Trans from "../Control.Monad.State.Trans/index.js";
import * as Control_Monad_Trans_Class from "../Control.Monad.Trans.Class/index.js";
import * as Control_Monad_Writer_Class from "../Control.Monad.Writer.Class/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_FunctorWithIndex from "../Data.FunctorWithIndex/index.js";
import * as Data_Lens_Getter from "../Data.Lens.Getter/index.js";
import * as Data_Lens_Internal_Forget from "../Data.Lens.Internal.Forget/index.js";
import * as Data_Lens_Record from "../Data.Lens.Record/index.js";
import * as Data_List from "../Data.List/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Debug from "../Debug/index.js";
import * as Foliage_Common from "../Foliage.Common/index.js";
import * as Foliage_Program from "../Foliage.Program/index.js";
import * as Halogen_HTML_Core from "../Halogen.HTML.Core/index.js";
import * as Halogen_HTML_Elements from "../Halogen.HTML.Elements/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
import * as Unsafe from "../Unsafe/index.js";
var show = /* #__PURE__ */ Data_Show.show(Foliage_Program["_Show_LatticeType"]);
var show1 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Program["_Show_Term"](Foliage_Program["_Eq_Show"]));
var eq = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(/* #__PURE__ */ Data_Map_Internal.eqMap(Foliage_Program["_Eq_VarName"])(/* #__PURE__ */ Foliage_Program["_Eq_Term"](Foliage_Program["_Eq_VarName"]))));
var sequence = /* #__PURE__ */ Data_Traversable.sequence(Data_Map_Internal.traversableMap);
var mapWithIndex = /* #__PURE__ */ Data_FunctorWithIndex.mapWithIndex(Data_Map_Internal.functorWithIndexMap);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var eq1 = /* #__PURE__ */ Data_Eq.eq(Foliage_Program["_Eq_VarName"]);
var show2 = /* #__PURE__ */ Data_Show.show(Foliage_Program["_Eq_Show"]);
var foldr = /* #__PURE__ */ Data_Foldable.foldr(Data_List_Types.foldableList);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Foliage_Program["_Traversable_TermF"]);
var lift = /* #__PURE__ */ Control_Monad_Trans_Class.lift(Control_Monad_Except_Trans.monadTransExceptT);
var show3 = /* #__PURE__ */ Data_Show.show(Foliage_Program["_Show_FixedName"]);
var lookupModule = /* #__PURE__ */ Foliage_Program.lookupModule({
    reflectSymbol: function () {
        return "functionDefs";
    }
})()(Foliage_Program["_Ord_FixedName"]);
var traverse1 = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray);
var show4 = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var fromFoldable = /* #__PURE__ */ Data_Map_Internal.fromFoldable(Data_Ord.ordString)(Data_Foldable.foldableArray);
var map = /* #__PURE__ */ Data_Functor.map(Data_Functor.functorArray);
var lmap = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorTuple);
var lookupModule1 = /* #__PURE__ */ Foliage_Program.lookupModule({
    reflectSymbol: function () {
        return "latticeTypeDefs";
    }
})()(Foliage_Program["_Ord_FixedName"]);
var rmap = /* #__PURE__ */ Data_Bifunctor.rmap(Data_Bifunctor.bifunctorTuple);
var union = /* #__PURE__ */ Data_Map_Internal.union(Foliage_Program["_Ord_VarName"]);
var eq2 = /* #__PURE__ */ Data_Eq.eq(Foliage_Program["_Eq_FixedName"]);
var lookup = /* #__PURE__ */ Data_Map_Internal.lookup(Foliage_Program["_Ord_FixedName"]);
var render = /* #__PURE__ */ Foliage_Program.render(Foliage_Program["_Render_Prop"]);
var show5 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Program["_Show_PropF"](Foliage_Program["_Eq_Show"]));
var pure = /* #__PURE__ */ Control_Applicative.pure(Control_Applicative.applicativeArray);
var show6 = /* #__PURE__ */ Data_Show.show(Data_Show.showBoolean);
var show7 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Common["_Show_Exc"]({
    reflectSymbol: function () {
        return "ignore prop";
    }
}));
var prop = /* #__PURE__ */ Data_Lens_Record.prop({
    reflectSymbol: function () {
        return "prop";
    }
})()();
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var insert = /* #__PURE__ */ Data_Map_Internal.insert(Foliage_Program["_Ord_FixedName"]);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Data_List_Types.applicativeList);
var lmap1 = /* #__PURE__ */ Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Data_Functor.functorArray);
var freshenVarNames = /* #__PURE__ */ Foliage_Program.freshenVarNames(Foliage_Program["_Show_RipeRule"])(Foliage_Program["_Traversable_RipeRuleF"]);
var render1 = /* #__PURE__ */ Foliage_Program.render(Foliage_Program["_Render_Rule"]);
var insertWith = /* #__PURE__ */ Data_Map_Internal.insertWith(Foliage_Program["_Ord_FixedName"]);
var append1 = /* #__PURE__ */ Data_Semigroup.append(Data_List_Types.semigroupList);
var fold = /* #__PURE__ */ Data_Foldable.fold(Data_List_Types.foldableList);
var fold1 = /* #__PURE__ */ fold(Data_List_Types.monoidList);
var traverse2 = /* #__PURE__ */ Data_Traversable.traverse(Data_List_Types.traversableList);
var show8 = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Foliage_Common["_Show_Exc"]({
    reflectSymbol: function () {
        return "apply rule";
    }
}));
var render2 = /* #__PURE__ */ Foliage_Program.render(Foliage_Program["_Render_TermSubst"]);
var show9 = /* #__PURE__ */ Data_Show.show(Data_Show.showInt);
var traceM = /* #__PURE__ */ Debug.traceM();
var fold2 = /* #__PURE__ */ fold(/* #__PURE__ */ Data_Map_Internal.monoidSemigroupMap()(Foliage_Program["_Ord_FixedName"])(Data_List_Types.semigroupList));
var unionWith = /* #__PURE__ */ Data_Map_Internal.unionWith(Foliage_Program["_Ord_FixedName"]);
var map1 = /* #__PURE__ */ Data_Functor.map(Data_List_Types.functorList);
var Env = function (x) {
    return x;
};
var Log = /* #__PURE__ */ (function () {
    function Log(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Log.create = function (value0) {
        return function (value1) {
            return new Log(value0, value1);
        };
    };
    return Log;
})();
var Ctx = function (x) {
    return x;
};
var throwError_compareTerm = function (dictMonadThrow) {
    var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
    return function (lty) {
        return function (t1) {
            return function (t2) {
                return throwError({
                    label: Foliage_Common["_compare"],
                    source: "compareTerm",
                    description: "in lattice " + (show(lty) + (", " + (show1(t1) + (" !<= " + show1(t2)))))
                });
            };
        };
    };
};
var tellLog = function (dictMonadState) {
    var bind = Control_Bind.bind((dictMonadState.Monad0()).Bind1());
    var get = Control_Monad_State_Class.get(dictMonadState);
    return function (dictMonadWriter) {
        var tell = Control_Monad_Writer_Class.tell(dictMonadWriter.MonadTell1());
        return function (r) {
            return bind(get)(function (env) {
                return tell([ new Log(r, new Data_Maybe.Just(env)) ]);
            });
        };
    };
};
var saturateTermSubst = function (dictMonad) {
    var applicativeExceptT = Control_Monad_Except_Trans.applicativeExceptT(dictMonad);
    var pure2 = Control_Applicative.pure(applicativeExceptT);
    var bindExceptT = Control_Monad_Except_Trans.bindExceptT(dictMonad);
    var bind = Control_Bind.bind(bindExceptT);
    var sequence1 = sequence(applicativeExceptT);
    var discard1 = discard(bindExceptT);
    var traverse_ = Data_Foldable.traverse_(applicativeExceptT)(Foliage_Program["_Foldable_TermF"]);
    var when = Control_Applicative.when(applicativeExceptT);
    var throwError = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(dictMonad));
    return function (sigma0) {
        var loop = function (prev_sigma) {
            return function (sigma) {
                var $455 = eq(prev_sigma)(new Data_Maybe.Just(sigma));
                if ($455) {
                    return pure2(sigma);
                };
                return bind(sequence1(mapWithIndex(function (x) {
                    return function (t) {
                        return discard1(traverse_(function (y) {
                            return when(eq1(x)(y))(throwError({
                                label: Type_Proxy["Proxy"].value,
                                source: "saturateTermSubst",
                                description: "The var " + (show2(x) + (" was substituted for " + (show1(t) + ", which contains the var itself.")))
                            }));
                        })(t))(function () {
                            return pure2(Foliage_Program.substTerm(sigma)(t));
                        });
                    };
                })(sigma)))(function (sigma$prime) {
                    return loop(new Data_Maybe.Just(sigma))(sigma$prime);
                });
            };
        };
        return loop(Data_Maybe.Nothing.value)(sigma0);
    };
};
var partitionEither = function (p) {
    return function (xs) {
        var select = function (a) {
            return function (v) {
                var v1 = p(a);
                if (v1 instanceof Data_Either.Left) {
                    return new Data_Tuple.Tuple(new Data_List_Types.Cons(v1.value0, v.value0), v.value1);
                };
                if (v1 instanceof Data_Either.Right) {
                    return new Data_Tuple.Tuple(v.value0, new Data_List_Types.Cons(v1.value0, v.value1));
                };
                throw new Error("Failed pattern match at Foliage.Interpretation (line 574, column 25 - line 576, column 30): " + [ v1.constructor.name ]);
            };
        };
        return foldr(select)(new Data_Tuple.Tuple(Data_List_Types.Nil.value, Data_List_Types.Nil.value))(xs);
    };
};
var evaluateTerm = function (dictMonadThrow) {
    var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
    return traverse((dictMonadThrow.Monad0()).Applicative0())(function (x) {
        return throwError({
            label: Foliage_Common["_error"],
            source: "evaluateTerm",
            description: "expected term to be a value, but found a variable " + show2(x)
        });
    });
};
var processSideHypothesis = function (dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var Monad0 = MonadAsk0.Monad0();
    var bind = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Monad0));
    var ask = Control_Monad_Reader_Class.ask(Control_Monad_Except_Trans.monadAskExceptT(MonadAsk0));
    var lift1 = lift(Monad0);
    var applicativeExceptT = Control_Monad_Except_Trans.applicativeExceptT(Monad0);
    var pure2 = Control_Applicative.pure(applicativeExceptT);
    var traverse3 = traverse1(applicativeExceptT);
    return function (dictMonadThrow) {
        var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
        var evaluateTerm1 = evaluateTerm(dictMonadThrow);
        return function (rule) {
            return function (v) {
                return bind(ask)(function (v1) {
                    return bind(Data_Maybe.maybe(lift1(throwError({
                        label: Foliage_Common["_error"],
                        source: "processSideHypothesis",
                        description: "could not function definition of the name " + show3(v.value0.functionName)
                    })))(pure2)(lookupModule(Type_Proxy["Proxy"].value)(v.value0.functionName)(v1.mod)))(function (functionDef) {
                        return bind(bind(traverse3(function ($722) {
                            return lift1(evaluateTerm1($722));
                        })(v.value0.args))(function (args) {
                            return bind(Data_Either.either(function (err) {
                                return lift1(throwError({
                                    label: Foliage_Common["_error"],
                                    source: "processSideHypothesis",
                                    description: "error in function " + (show4(functionDef.value0.name) + (": " + err))
                                }));
                            })(pure2)(Foliage_Common.fromOpaque(functionDef.value0.impl)(fromFoldable(map(lmap(Data_Tuple.fst))(Data_Array.zip(functionDef.value0.inputs)(args))))))(function (result) {
                                return pure2(result);
                            });
                        }))(function (result) {
                            return pure2(Foliage_Program.substRule(Data_Map_Internal.singleton(v.value0.resultVarVarName)(result))(rule));
                        });
                    });
                });
            };
        };
    };
};
var processSideHypotheses = function (dictMonadReader) {
    var Monad0 = (dictMonadReader.MonadAsk0()).Monad0();
    var bind = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Monad0));
    var processSideHypothesis1 = processSideHypothesis(dictMonadReader);
    var pure2 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Monad0));
    return function (dictMonadThrow) {
        var processSideHypothesis2 = processSideHypothesis1(dictMonadThrow);
        return function (rule) {
            return function (sides) {
                return Data_Array.foldr(function (side) {
                    return function (m_rule) {
                        return bind(m_rule)(function (rule$prime) {
                            return processSideHypothesis2(rule$prime)(side);
                        });
                    };
                })(pure2(rule))(sides);
            };
        };
    };
};
var compareTerm = function (dictMonadThrow) {
    var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
    return function (dictMonadReader) {
        var MonadAsk0 = dictMonadReader.MonadAsk0();
        var Monad0 = MonadAsk0.Monad0();
        var pure2 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Monad0));
        var bind = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(Monad0));
        var ask = Control_Monad_Reader_Class.ask(Control_Monad_Except_Trans.monadAskExceptT(MonadAsk0));
        var monadThrowExceptT = Control_Monad_Except_Trans.monadThrowExceptT(Monad0);
        var throwError1 = Control_Monad_Error_Class.throwError(monadThrowExceptT);
        var lift1 = lift(Monad0);
        var throwError_compareTerm1 = throwError_compareTerm(monadThrowExceptT);
        var map2 = Data_Functor.map(Control_Monad_Except_Trans.functorExceptT(((Monad0.Bind1()).Apply0()).Functor0()));
        return function (dictMonadWriter) {
            return function (v) {
                return function (v1) {
                    return function (v2) {
                        if (v1 instanceof Foliage_Program.VarTerm) {
                            return pure2(new Data_Tuple.Tuple(Data_Ordering.EQ.value, Data_Map_Internal.singleton(v1.value0)(v2)));
                        };
                        if (v2 instanceof Foliage_Program.VarTerm) {
                            return pure2(new Data_Tuple.Tuple(Data_Ordering.EQ.value, Data_Map_Internal.singleton(v2.value0)(v1)));
                        };
                        if (v instanceof Foliage_Program.NamedLatticeType) {
                            return bind(ask)(function (v3) {
                                var v4 = lookupModule1(Type_Proxy["Proxy"].value)(v.value0)(v3.mod);
                                if (v4 instanceof Data_Maybe.Nothing) {
                                    return throwError1({
                                        label: Foliage_Common["_compare"],
                                        source: "comapreTerm " + (show(v) + (" " + (show1(v1) + (" " + show1(v2))))),
                                        description: "could not find lattice type definition with name " + show3(v.value0)
                                    });
                                };
                                if (v4 instanceof Data_Maybe.Just) {
                                    if (v4.value0 instanceof Foliage_Program.LatticeTypeDef) {
                                        return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v4.value0.value0)(v1)(v2);
                                    };
                                    if (v4.value0 instanceof Foliage_Program.ExternalLatticeTypeDef) {
                                        var v5 = Control_Monad_Except.runExcept(Control_Monad_Except_Trans.runExceptT(Foliage_Common.fromOpaque(v4.value0.value0.compare_impl)(new Data_Tuple.Tuple(v1, v2))));
                                        if (v5 instanceof Data_Either.Left) {
                                            return throwError1(v5.value0);
                                        };
                                        if (v5 instanceof Data_Either.Right && v5.value0 instanceof Data_Either.Left) {
                                            return lift1(throwError(Foliage_Common.map_Exc_label(Foliage_Common["_error"])(v5.value0.value0)));
                                        };
                                        if (v5 instanceof Data_Either.Right && v5.value0 instanceof Data_Either.Right) {
                                            return pure2(new Data_Tuple.Tuple(v5.value0.value0.value0, v5.value0.value0.value1));
                                        };
                                        throw new Error("Failed pattern match at Foliage.Interpretation (line 494, column 9 - line 497, column 58): " + [ v5.constructor.name ]);
                                    };
                                    throw new Error("Failed pattern match at Foliage.Interpretation (line 489, column 28 - line 497, column 58): " + [ v4.value0.constructor.name ]);
                                };
                                throw new Error("Failed pattern match at Foliage.Interpretation (line 487, column 3 - line 497, column 58): " + [ v4.constructor.name ]);
                            });
                        };
                        if (v instanceof Foliage_Program.UnitLatticeType) {
                            var v3 = new Data_Tuple.Tuple(v1, v2);
                            if (v3.value0 instanceof Foliage_Program.UnitTerm && v3.value1 instanceof Foliage_Program.UnitTerm) {
                                return pure2(new Data_Tuple.Tuple(Data_Ordering.EQ.value, Data_Map_Internal.empty));
                            };
                            return lift1(throwError({
                                label: Foliage_Common["_error"],
                                source: "compareTerm",
                                description: "type error; expected " + (show4(show1(v1)) + (" and " + (show4(show1(v2)) + (" to have the type " + (show4(show(v)) + ".")))))
                            }));
                        };
                        if (v instanceof Foliage_Program.SumLatticeType && v.value0 instanceof Foliage_Program.LeftGreaterThanRight_SumLatticeTypeOrdering) {
                            var v3 = new Data_Tuple.Tuple(v1, v2);
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value1)(v3.value0.value0)(v3.value1.value0);
                            };
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return pure2(new Data_Tuple.Tuple(Data_Ordering.GT.value, Data_Map_Internal.empty));
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return pure2(new Data_Tuple.Tuple(Data_Ordering.LT.value, Data_Map_Internal.empty));
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value2)(v3.value0.value0)(v3.value1.value0);
                            };
                            return lift1(throwError({
                                label: Foliage_Common["_error"],
                                source: "compareTerm",
                                description: "type error; expected " + (show4(show1(v1)) + (" and " + (show4(show1(v2)) + (" to have the type " + (show4(show(v)) + ".")))))
                            }));
                        };
                        if (v instanceof Foliage_Program.SumLatticeType && v.value0 instanceof Foliage_Program.LeftLessThanRight_SumLatticeTypeOrdering) {
                            var v3 = new Data_Tuple.Tuple(v1, v2);
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value1)(v3.value0.value0)(v3.value1.value0);
                            };
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return pure2(new Data_Tuple.Tuple(Data_Ordering.LT.value, Data_Map_Internal.empty));
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return pure2(new Data_Tuple.Tuple(Data_Ordering.GT.value, Data_Map_Internal.empty));
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value2)(v3.value0.value0)(v3.value1.value0);
                            };
                            return lift1(throwError({
                                label: Foliage_Common["_error"],
                                source: "compareTerm",
                                description: "type error; expected " + (show4(show1(v1)) + (" and " + (show4(show1(v2)) + (" to have the type " + (show4(show(v)) + ".")))))
                            }));
                        };
                        if (v instanceof Foliage_Program.SumLatticeType && v.value0 instanceof Foliage_Program.LeftIncomparableRight_SumLatticeTypeOrdering) {
                            var v3 = new Data_Tuple.Tuple(v1, v2);
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value1)(v3.value0.value0)(v3.value1.value0);
                            };
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return throwError_compareTerm1(v)(v3.value0.value0)(v3.value1.value0);
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return throwError_compareTerm1(v)(v3.value0.value0)(v3.value1.value0);
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value2)(v3.value0.value0)(v3.value1.value0);
                            };
                            return lift1(throwError({
                                label: Foliage_Common["_error"],
                                source: "compareTerm",
                                description: "type error; expected " + (show4(show1(v1)) + (" and " + (show4(show1(v2)) + (" to have the type " + (show4(show(v)) + ".")))))
                            }));
                        };
                        if (v instanceof Foliage_Program.SumLatticeType && v.value0 instanceof Foliage_Program.LeftEqualRight_SumLatticeTypeOrdering) {
                            var v3 = new Data_Tuple.Tuple(v1, v2);
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value1)(v3.value0.value0)(v3.value1.value0);
                            };
                            if (v3.value0 instanceof Foliage_Program.LeftTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return pure2(new Data_Tuple.Tuple(Data_Ordering.EQ.value, Data_Map_Internal.empty));
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.LeftTerm) {
                                return pure2(new Data_Tuple.Tuple(Data_Ordering.EQ.value, Data_Map_Internal.empty));
                            };
                            if (v3.value0 instanceof Foliage_Program.RightTerm && v3.value1 instanceof Foliage_Program.RightTerm) {
                                return compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value2)(v3.value0.value0)(v3.value1.value0);
                            };
                            return lift1(throwError({
                                label: Foliage_Common["_error"],
                                source: "compareTerm",
                                description: "type error; expected " + (show4(show1(v1)) + (" and " + (show4(show1(v2)) + (" to have the type " + (show4(show(v)) + ".")))))
                            }));
                        };
                        if (v instanceof Foliage_Program.ProductLatticeType) {
                            var v3 = new Data_Tuple.Tuple(v1, v2);
                            if (v3.value0 instanceof Foliage_Program.PairTerm && v3.value1 instanceof Foliage_Program.PairTerm) {
                                return bind(compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value1)(v3.value0.value0)(v3.value1.value0))(function (v4) {
                                    if (v4.value0 instanceof Data_Ordering.LT) {
                                        return pure2(new Data_Tuple.Tuple(Data_Ordering.LT.value, v4.value1));
                                    };
                                    if (v4.value0 instanceof Data_Ordering.EQ) {
                                        return bind(pure2(Foliage_Program.substTerm(v4.value1)(v3.value0.value1)))(function (t1_21) {
                                            return bind(pure2(Foliage_Program.substTerm(v4.value1)(v3.value1.value1)))(function (t2_21) {
                                                return map2(rmap(union(v4.value1)))(compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value2)(t1_21)(t2_21));
                                            });
                                        });
                                    };
                                    if (v4.value0 instanceof Data_Ordering.GT) {
                                        return pure2(new Data_Tuple.Tuple(Data_Ordering.GT.value, v4.value1));
                                    };
                                    throw new Error("Failed pattern match at Foliage.Interpretation (line 534, column 11 - line 540, column 44): " + [ v4.constructor.name ]);
                                });
                            };
                            return lift1(throwError({
                                label: Foliage_Common["_error"],
                                source: "compareTerm",
                                description: "type error; expected " + (show4(show1(v1)) + (" and " + (show4(show1(v2)) + (" to have the type " + (show4(show(v)) + ".")))))
                            }));
                        };
                        if (v instanceof Foliage_Program.SetLatticeType) {
                            return Unsafe.todo("compareTerm SetLatticeType");
                        };
                        if (v instanceof Foliage_Program.OppositeLatticeType) {
                            return bind(compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value0)(v1)(v2))(function (v3) {
                                if (v3.value0 instanceof Data_Ordering.LT) {
                                    return pure2(new Data_Tuple.Tuple(Data_Ordering.GT.value, v3.value1));
                                };
                                if (v3.value0 instanceof Data_Ordering.EQ) {
                                    return pure2(new Data_Tuple.Tuple(Data_Ordering.EQ.value, v3.value1));
                                };
                                if (v3.value0 instanceof Data_Ordering.GT) {
                                    return pure2(new Data_Tuple.Tuple(Data_Ordering.LT.value, v3.value1));
                                };
                                throw new Error("Failed pattern match at Foliage.Interpretation (line 547, column 9 - line 550, column 42): " + [ v3.constructor.name ]);
                            });
                        };
                        if (v instanceof Foliage_Program.FlatLatticeType) {
                            return bind(compareTerm(dictMonadThrow)(dictMonadReader)(dictMonadWriter)(v.value0)(v1)(v2))(function (v3) {
                                if (v3.value0 instanceof Data_Ordering.LT) {
                                    return throwError_compareTerm1(new Foliage_Program.FlatLatticeType(v.value0))(v1)(v2);
                                };
                                if (v3.value0 instanceof Data_Ordering.EQ) {
                                    return pure2(new Data_Tuple.Tuple(Data_Ordering.EQ.value, v3.value1));
                                };
                                if (v3.value0 instanceof Data_Ordering.GT) {
                                    return throwError_compareTerm1(new Foliage_Program.FlatLatticeType(v.value0))(v1)(v2);
                                };
                                throw new Error("Failed pattern match at Foliage.Interpretation (line 554, column 9 - line 557, column 75): " + [ v3.constructor.name ]);
                            });
                        };
                        if (v instanceof Foliage_Program.PowerLatticeType) {
                            return Unsafe.todo("compareTerm PowerLatticeType");
                        };
                        throw new Error("Failed pattern match at Foliage.Interpretation (line 466, column 1 - line 471, column 75): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
                    };
                };
            };
        };
    };
};
var compareProp = function (dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var Monad0 = MonadAsk0.Monad0();
    var bindExceptT = Control_Monad_Except_Trans.bindExceptT(Monad0);
    var discard1 = discard(bindExceptT);
    var applicativeExceptT = Control_Monad_Except_Trans.applicativeExceptT(Monad0);
    var unless = Control_Applicative.unless(applicativeExceptT);
    var throwError = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(Monad0));
    var bind = Control_Bind.bind(bindExceptT);
    var ask = Control_Monad_Reader_Class.ask(Control_Monad_Except_Trans.monadAskExceptT(MonadAsk0));
    var lift1 = lift(Monad0);
    var pure2 = Control_Applicative.pure(applicativeExceptT);
    return function (dictMonadThrow) {
        var throwError1 = Control_Monad_Error_Class.throwError(dictMonadThrow);
        var compareTerm1 = compareTerm(dictMonadThrow)(dictMonadReader);
        return function (dictMonadWriter) {
            var compareTerm2 = compareTerm1(dictMonadWriter);
            return function (v) {
                return function (v1) {
                    return discard1(unless(eq2(v.value0)(v1.value0))(throwError({
                        label: Foliage_Common["_compare"],
                        source: "compareProp",
                        description: show3(v.value0) + (" != " + show3(v1.value0))
                    })))(function () {
                        return bind(ask)(function (v2) {
                            return bind((function () {
                                var v3 = lookup(v.value0)(v2.mod.value0.relations);
                                if (v3 instanceof Data_Maybe.Nothing) {
                                    return lift1(throwError1({
                                        label: Foliage_Common["_error"],
                                        source: "compareProp",
                                        description: "could not find relation " + show4(show3(v.value0))
                                    }));
                                };
                                if (v3 instanceof Data_Maybe.Just) {
                                    return pure2(v3.value0.value0.domain);
                                };
                                throw new Error("Failed pattern match at Foliage.Interpretation (line 459, column 13 - line 461, column 46): " + [ v3.constructor.name ]);
                            })())(function (domain) {
                                return compareTerm2(domain)(v.value1)(v1.value1);
                            });
                        });
                    });
                };
            };
        };
    };
};
var askRenderCtx = function (dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var Monad0 = MonadAsk0.Monad0();
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return Control_Bind.bind(Monad0.Bind1())(Control_Monad_Reader_Class.ask(MonadAsk0))(function (v) {
        return pure2({
            mod: v.mod
        });
    });
};
var joinProps = function (dictMonad) {
    var foldM = Data_List.foldM(Control_Monad_Except_Trans.monadExceptT(dictMonad));
    var bindExceptT = Control_Monad_Except_Trans.bindExceptT(dictMonad);
    var bind = Control_Bind.bind(bindExceptT);
    var bindFlipped = Control_Bind.bindFlipped(bindExceptT);
    var pure2 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad));
    var discard1 = discard(bindExceptT);
    var throwError = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(dictMonad));
    var lift1 = lift(dictMonad);
    return function (dictMonadReader) {
        var askRenderCtx1 = askRenderCtx(Control_Monad_Except_Trans.monadReaderExceptT(dictMonadReader));
        var compareProp1 = compareProp(dictMonadReader);
        return function (dictMonadThrow) {
            var compareProp2 = compareProp1(dictMonadThrow);
            return function (dictMonadState) {
                var tellLog1 = tellLog(Control_Monad_Except_Trans.monadStateExceptT(dictMonadState));
                return function (dictMonadWriter) {
                    var tellLog2 = tellLog1(Control_Monad_Except_Trans.monadWriterExceptT(dictMonadWriter));
                    var compareProp3 = compareProp2(dictMonadWriter);
                    return function (g) {
                        return function (props) {
                            return function (prop1) {
                                return foldM(function (known_props) {
                                    return function (prop$prime) {
                                        return bind(askRenderCtx1)(function (renderCtx) {
                                            return bindFlipped(function (v) {
                                                if (v instanceof Data_Either.Left) {
                                                    return pure2(new Data_List_Types.Cons(prop$prime, known_props));
                                                };
                                                if (v instanceof Data_Either.Right && v.value0.value0 instanceof Data_Ordering.LT) {
                                                    return discard1(tellLog2({
                                                        label: "joinProps . props subsume prop",
                                                        messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(Data_Lens_Getter.viewOn(prop1)(g)))))) ]
                                                    }))(function () {
                                                        return throwError({
                                                            label: Type_Proxy["Proxy"].value,
                                                            source: "joinProps",
                                                            description: show5(Data_Lens_Getter.viewOn(prop1)(g)) + (" is subsumed by " + show5(Data_Lens_Getter.viewOn(prop$prime)(g)))
                                                        });
                                                    });
                                                };
                                                if (v instanceof Data_Either.Right && v.value0.value0 instanceof Data_Ordering.EQ) {
                                                    return discard1(tellLog2({
                                                        label: "joinProps . props subsume prop",
                                                        messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(Data_Lens_Getter.viewOn(prop1)(g)))))) ]
                                                    }))(function () {
                                                        return throwError({
                                                            label: Type_Proxy["Proxy"].value,
                                                            source: "joinProps",
                                                            description: show5(Data_Lens_Getter.viewOn(prop1)(g)) + (" is subsumed by " + show5(Data_Lens_Getter.viewOn(prop$prime)(g)))
                                                        });
                                                    });
                                                };
                                                if (v instanceof Data_Either.Right && v.value0.value0 instanceof Data_Ordering.GT) {
                                                    return discard1(tellLog2({
                                                        label: "joinProps . prop subsumes prop'",
                                                        messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(Data_Lens_Getter.viewOn(prop1)(g)))))), new Data_Tuple.Tuple("prop'", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(Data_Lens_Getter.viewOn(prop$prime)(g)))))) ]
                                                    }))(function () {
                                                        return pure2(known_props);
                                                    });
                                                };
                                                throw new Error("Failed pattern match at Foliage.Interpretation (line 195, column 29 - line 209, column 37): " + [ v.constructor.name ]);
                                            })(lift1(Control_Monad_Except_Trans.runExceptT(compareProp3(Data_Lens_Getter.viewOn(prop1)(g))(Data_Lens_Getter.viewOn(prop$prime)(g)))));
                                        });
                                    };
                                })(Data_List_Types.Nil.value)(props);
                            };
                        };
                    };
                };
            };
        };
    };
};
var insertProp = function (dictMonad) {
    var bind = Control_Bind.bind(Control_Monad_Except_Trans.bindExceptT(dictMonad));
    var joinProps1 = joinProps(dictMonad);
    var pure2 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(dictMonad));
    return function (dictMonadReader) {
        var joinProps2 = joinProps1(dictMonadReader);
        return function (dictMonadThrow) {
            var joinProps3 = joinProps2(dictMonadThrow);
            return function (dictMonadState) {
                var joinProps4 = joinProps3(dictMonadState);
                return function (dictMonadWriter) {
                    var joinProps5 = joinProps4(dictMonadWriter);
                    return function (g) {
                        return function (props) {
                            return function (prop1) {
                                return Control_Monad_Except_Trans.runExceptT(bind(joinProps5(g)(props)(prop1))(function (props$prime) {
                                    return pure2(Data_List.snoc(props$prime)(prop1));
                                }));
                            };
                        };
                    };
                };
            };
        };
    };
};
var deferProp = function (dictMonadState) {
    var tellLog1 = tellLog(dictMonadState);
    var get = Control_Monad_State_Class.get(dictMonadState);
    var modify_ = Control_Monad_State_Class.modify_(dictMonadState);
    return function (dictMonadWriter) {
        var tellLog2 = tellLog1(dictMonadWriter);
        return function (dictMonadReader) {
            var Monad0 = (dictMonadReader.MonadAsk0()).Monad0();
            var Bind1 = Monad0.Bind1();
            var bind = Control_Bind.bind(Bind1);
            var askRenderCtx1 = askRenderCtx(dictMonadReader);
            var discard1 = discard(Bind1);
            var insertProp1 = insertProp(Monad0)(dictMonadReader);
            var bindFlipped = Control_Bind.bindFlipped(Bind1);
            var joinProps1 = joinProps(Monad0)(dictMonadReader);
            return function (dictMonadThrow) {
                var insertProp2 = insertProp1(dictMonadThrow)(dictMonadState)(dictMonadWriter);
                var joinProps2 = joinProps1(dictMonadThrow)(dictMonadState)(dictMonadWriter);
                return function (isNew) {
                    return function (v) {
                        return bind(askRenderCtx1)(function (renderCtx) {
                            return discard1(tellLog2({
                                label: "defer prop",
                                messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(v))))), new Data_Tuple.Tuple("isNew", Halogen_HTML_Elements.div([  ])(pure(Halogen_HTML_Core.text(show6(isNew))))) ]
                            }))(function () {
                                return bind(get)(function (v1) {
                                    var success = function (active_props) {
                                        return discard1(tellLog2({
                                            label: "defer prop . success",
                                            messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(v))))) ]
                                        }))(function () {
                                            return modify_(function (v2) {
                                                return {
                                                    gas: v2.gas,
                                                    ripe_rules: v2.ripe_rules,
                                                    known_props: v2.known_props,
                                                    active_props: active_props
                                                };
                                            });
                                        });
                                    };
                                    var failure = function (exc) {
                                        return tellLog2({
                                            label: "defer prop . failure",
                                            messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(v))))), new Data_Tuple.Tuple("reason", Halogen_HTML_Elements.div([  ])(pure(Halogen_HTML_Core.text(show7(exc))))) ]
                                        });
                                    };
                                    return bind(insertProp2(prop(Type_Proxy["Proxy"].value)(Data_Lens_Internal_Forget.strongForget))(v1.active_props)({
                                        prop: v,
                                        isNew: isNew
                                    }))(function (v2) {
                                        if (v2 instanceof Data_Either.Left) {
                                            return failure(v2.value0);
                                        };
                                        if (v2 instanceof Data_Either.Right) {
                                            if (isNew) {
                                                return Data_Maybe.maybe(success(v2.value0))(function (known_props) {
                                                    return bindFlipped(function (v3) {
                                                        if (v3 instanceof Data_Either.Left) {
                                                            return failure(v3.value0);
                                                        };
                                                        if (v3 instanceof Data_Either.Right) {
                                                            return success(v2.value0);
                                                        };
                                                        throw new Error("Failed pattern match at Foliage.Interpretation (line 307, column 35 - line 309, column 56): " + [ v3.constructor.name ]);
                                                    })(Control_Monad_Except_Trans.runExceptT(joinProps2(identity)(known_props)(v)));
                                                })(lookup(v.value0)(v1.known_props));
                                            };
                                            return success(v2.value0);
                                        };
                                        throw new Error("Failed pattern match at Foliage.Interpretation (line 297, column 9 - line 312, column 33): " + [ v2.constructor.name ]);
                                    });
                                });
                            });
                        });
                    };
                };
            };
        };
    };
};
var learnProp = function (dictMonadReader) {
    var Monad0 = (dictMonadReader.MonadAsk0()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var askRenderCtx1 = askRenderCtx(dictMonadReader);
    var discard1 = discard(Bind1);
    var bindFlipped = Control_Bind.bindFlipped(Bind1);
    var insertProp1 = insertProp(Monad0)(dictMonadReader);
    return function (dictMonadState) {
        var get = Control_Monad_State_Class.get(dictMonadState);
        var tellLog1 = tellLog(dictMonadState);
        var modify_ = Control_Monad_State_Class.modify_(dictMonadState);
        return function (dictMonadThrow) {
            var insertProp2 = insertProp1(dictMonadThrow)(dictMonadState);
            return function (dictMonadWriter) {
                var tellLog2 = tellLog1(dictMonadWriter);
                var insertProp3 = insertProp2(dictMonadWriter);
                return function (v) {
                    return bind(get)(function (v1) {
                        var success = function (known_props$prime) {
                            return bind(askRenderCtx1)(function (renderCtx) {
                                return discard1(tellLog2({
                                    label: "learn prop . success",
                                    messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(v))))) ]
                                }))(function () {
                                    return modify_(function (v2) {
                                        return {
                                            gas: v2.gas,
                                            ripe_rules: v2.ripe_rules,
                                            active_props: v2.active_props,
                                            known_props: known_props$prime
                                        };
                                    });
                                });
                            });
                        };
                        var failure = function (exc) {
                            return tellLog2({
                                label: "learn prop . failure",
                                messages: [ new Data_Tuple.Tuple("reason", Halogen_HTML_Elements.div([  ])(pure(Halogen_HTML_Core.text(show7(exc))))) ]
                            });
                        };
                        return (function (v2) {
                            if (v2 instanceof Data_Maybe.Nothing) {
                                return success(insert(v.value0)(pure1(v))(v1.known_props));
                            };
                            if (v2 instanceof Data_Maybe.Just) {
                                return bindFlipped(function (v3) {
                                    if (v3 instanceof Data_Either.Left) {
                                        return failure(v3.value0);
                                    };
                                    if (v3 instanceof Data_Either.Right) {
                                        return success(insert(v.value0)(v3.value0)(v1.known_props));
                                    };
                                    throw new Error("Failed pattern match at Foliage.Interpretation (line 175, column 27 - line 177, column 100): " + [ v3.constructor.name ]);
                                })(insertProp3(identity)(v2.value0)(v));
                            };
                            throw new Error("Failed pattern match at Foliage.Interpretation (line 171, column 7 - line 177, column 100): " + [ v2.constructor.name ]);
                        })(lookup(v.value0)(v1.known_props));
                    });
                };
            };
        };
    };
};
var applyRipeRuleToProp = function (dictMonadReader) {
    var Monad0 = (dictMonadReader.MonadAsk0()).Monad0();
    var bindExceptT = Control_Monad_Except_Trans.bindExceptT(Monad0);
    var bind = Control_Bind.bind(bindExceptT);
    var bindFlipped = Control_Bind.bindFlipped(bindExceptT);
    var saturateTermSubst1 = saturateTermSubst(Monad0);
    var pure2 = Control_Applicative.pure(Control_Monad_Except_Trans.applicativeExceptT(Monad0));
    var throwError = Control_Monad_Error_Class.throwError(Control_Monad_Except_Trans.monadThrowExceptT(Monad0));
    var map2 = Data_Functor.map(((Monad0.Bind1()).Apply0()).Functor0());
    var compareProp1 = compareProp(dictMonadReader);
    var processSideHypotheses1 = processSideHypotheses(dictMonadReader);
    return function (dictMonadThrow) {
        var compareProp2 = compareProp1(dictMonadThrow);
        var processSideHypotheses2 = processSideHypotheses1(dictMonadThrow);
        return function (dictMonadWriter) {
            var compareProp3 = compareProp2(dictMonadWriter);
            return function (dictMonadState) {
                return function (v) {
                    return function (prop1) {
                        return bind(bindFlipped(saturateTermSubst1)(bindFlipped(function (v1) {
                            if (v1.value0 instanceof Data_Ordering.LT) {
                                return pure2(v1.value1);
                            };
                            if (v1.value0 instanceof Data_Ordering.EQ) {
                                return pure2(v1.value1);
                            };
                            return throwError({
                                label: Foliage_Common["_apply_rule"],
                                source: "applyRipeRuleToProp",
                                description: show5(v.value0.hypothesis.value0) + (" < " + show5(prop1))
                            });
                        })(Control_Monad_Except_Trans.mapExceptT(map2(lmap1(Foliage_Common.map_Exc_label(Foliage_Common["_apply_rule"]))))(compareProp3(v.value0.hypothesis.value0)(prop1)))))(function (sigma) {
                            var rule$prime = Foliage_Program.substRule(sigma)(v["value0"]["rule'"]);
                            var hyp_sides$prime = mapFlipped(v.value0.hypothesis.value1)(Foliage_Program.substSideHypothesis(sigma));
                            return bind(Control_Monad_Except_Trans.mapExceptT(map2(lmap1(Foliage_Common.map_Exc_label(Foliage_Common["_apply_rule"]))))(processSideHypotheses2(rule$prime)(hyp_sides$prime)))(function (rule$prime$prime) {
                                return pure2(new Data_Tuple.Tuple(sigma, rule$prime$prime));
                            });
                        });
                    };
                };
            };
        };
    };
};
var deferRipeRule = function (dictMonadReader) {
    var Monad0 = (dictMonadReader.MonadAsk0()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var pure2 = Control_Applicative.pure(Applicative0);
    var askRenderCtx1 = askRenderCtx(dictMonadReader);
    var discard1 = discard(Bind1);
    var filterM = Data_List.filterM(Monad0);
    var map2 = Data_Functor.map((Bind1.Apply0()).Functor0());
    var applyRipeRuleToProp1 = applyRipeRuleToProp(dictMonadReader);
    var traverse_ = Data_Foldable.traverse_(Applicative0)(Data_List_Types.foldableList);
    return function (dictMonadState) {
        var tellLog1 = tellLog(dictMonadState);
        var modify_ = Control_Monad_State_Class.modify_(dictMonadState);
        var get = Control_Monad_State_Class.get(dictMonadState);
        var deferProp1 = deferProp(dictMonadState);
        return function (dictMonadThrow) {
            var applyRipeRuleToProp2 = applyRipeRuleToProp1(dictMonadThrow);
            return function (dictMonadWriter) {
                var tellLog2 = tellLog1(dictMonadWriter);
                var applyRipeRuleToProp3 = applyRipeRuleToProp2(dictMonadWriter)(dictMonadState);
                var deferProp2 = deferProp1(dictMonadWriter)(dictMonadReader)(dictMonadThrow);
                return function (ripe_rule_) {
                    return bind(pure2(freshenVarNames(ripe_rule_)))(function (v) {
                        return bind(askRenderCtx1)(function (renderCtx) {
                            return discard1(tellLog2({
                                label: "defer rule",
                                messages: [ new Data_Tuple.Tuple("ripe_rule", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render1(Foliage_Program.from_RipeRule_to_Rule(v)))))) ]
                            }))(function () {
                                return discard1(modify_(function (v1) {
                                    return {
                                        gas: v1.gas,
                                        known_props: v1.known_props,
                                        active_props: v1.active_props,
                                        ripe_rules: insertWith(append1)(v.value0.hypothesis.value0.value0)(Data_List.singleton(v))(v1.ripe_rules)
                                    };
                                }))(function () {
                                    return bind(get)(function (v1) {
                                        return bind(Data_Maybe.maybe(pure2(Data_List_Types.Nil.value))(filterM(function (prop1) {
                                            return map2(Data_Either.either(Data_Function["const"](false))(Data_Function["const"](true)))(Control_Monad_Except_Trans.runExceptT(applyRipeRuleToProp3(v)(prop1)));
                                        }))(lookup(v.value0.hypothesis.value0.value0)(v1.known_props)))(function (props) {
                                            return traverse_(deferProp2(false))(props);
                                        });
                                    });
                                });
                            });
                        });
                    });
                };
            };
        };
    };
};
var resolveProp = function (dictMonadReader) {
    var Monad0 = (dictMonadReader.MonadAsk0()).Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var askRenderCtx1 = askRenderCtx(dictMonadReader);
    var discard1 = discard(Bind1);
    var map2 = Data_Functor.map((Bind1.Apply0()).Functor0());
    var Applicative0 = Monad0.Applicative0();
    var traverse3 = traverse2(Applicative0);
    var applyRipeRuleToProp1 = applyRipeRuleToProp(dictMonadReader);
    var pure2 = Control_Applicative.pure(Applicative0);
    var traverse_ = Data_Foldable.traverse_(Applicative0)(Data_List_Types.foldableList);
    var deferRipeRule1 = deferRipeRule(dictMonadReader);
    return function (dictMonadState) {
        var tellLog1 = tellLog(dictMonadState);
        var get = Control_Monad_State_Class.get(dictMonadState);
        var deferProp1 = deferProp(dictMonadState);
        var deferRipeRule2 = deferRipeRule1(dictMonadState);
        return function (dictMonadThrow) {
            var applyRipeRuleToProp2 = applyRipeRuleToProp1(dictMonadThrow);
            var deferRipeRule3 = deferRipeRule2(dictMonadThrow);
            return function (dictMonadWriter) {
                var tellLog2 = tellLog1(dictMonadWriter);
                var applyRipeRuleToProp3 = applyRipeRuleToProp2(dictMonadWriter)(dictMonadState);
                var deferProp2 = deferProp1(dictMonadWriter)(dictMonadReader)(dictMonadThrow);
                var deferRipeRule4 = deferRipeRule3(dictMonadWriter);
                return function (v) {
                    return bind(askRenderCtx1)(function (renderCtx) {
                        return discard1(tellLog2({
                            label: "resolve prop",
                            messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(v))))) ]
                        }))(function () {
                            return bind(get)(function (v1) {
                                return bind(map2(fold1)(traverse3(function (ripe_rule) {
                                    return bind(Control_Monad_Except_Trans.runExceptT(applyRipeRuleToProp3(ripe_rule)(v)))(function (v2) {
                                        if (v2 instanceof Data_Either.Left) {
                                            return discard1(tellLog2({
                                                label: "resolve prop . apply rule . failure",
                                                messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(v))))), new Data_Tuple.Tuple("ripe_rule", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render1(Foliage_Program.from_RipeRule_to_Rule(ripe_rule)))))), new Data_Tuple.Tuple("reason", Halogen_HTML_Elements.div([  ])(pure(Halogen_HTML_Core.text(show8(v2.value0))))) ]
                                            }))(function () {
                                                return pure2(Data_List_Types.Nil.value);
                                            });
                                        };
                                        if (v2 instanceof Data_Either.Right) {
                                            return discard1(tellLog2({
                                                label: "resolve prop . apply rule . success",
                                                messages: [ new Data_Tuple.Tuple("prop", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render(v))))), new Data_Tuple.Tuple("ripe_rule", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render1(Foliage_Program.from_RipeRule_to_Rule(ripe_rule)))))), new Data_Tuple.Tuple("sigma", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render2(v2.value0.value0))))), new Data_Tuple.Tuple("sigma rule", Halogen_HTML_Elements.div([  ])(Data_Function.flip(Control_Monad_Reader.runReader)(renderCtx)(Foliage_Program.line(render1(v2.value0.value1))))) ]
                                            }))(function () {
                                                var v3 = Foliage_Program.nextHypothesis(v2.value0.value1);
                                                if (v3 instanceof Data_Either.Left) {
                                                    return discard1(deferProp2(true)(v3.value0))(function () {
                                                        return pure2(Data_List_Types.Nil.value);
                                                    });
                                                };
                                                if (v3 instanceof Data_Either.Right) {
                                                    return pure2(Data_List.singleton(v3.value0));
                                                };
                                                throw new Error("Failed pattern match at Foliage.Interpretation (line 266, column 23 - line 272, column 59): " + [ v3.constructor.name ]);
                                            });
                                        };
                                        throw new Error("Failed pattern match at Foliage.Interpretation (line 245, column 21 - line 272, column 59): " + [ v2.constructor.name ]);
                                    });
                                })(Data_Maybe.fromMaybe(Data_List_Types.Nil.value)(lookup(v.value0)(v1.ripe_rules)))))(function (v2) {
                                    return traverse_(deferRipeRule4)(v2);
                                });
                            });
                        });
                    });
                };
            };
        };
    };
};
var fixpointFocusModule = function (dictMonadReader) {
    var MonadAsk0 = dictMonadReader.MonadAsk0();
    var Monad0 = MonadAsk0.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var ask = Control_Monad_Reader_Class.ask(MonadAsk0);
    var discard1 = discard(Bind1);
    var Applicative0 = Monad0.Applicative0();
    var when = Control_Applicative.when(Applicative0);
    var pure2 = Control_Applicative.pure(Applicative0);
    var learnProp1 = learnProp(dictMonadReader);
    var resolveProp1 = resolveProp(dictMonadReader);
    return function (dictMonadState) {
        var modify = Control_Monad_State_Class.modify(dictMonadState);
        var tellLog1 = tellLog(dictMonadState);
        var modify_ = Control_Monad_State_Class.modify_(dictMonadState);
        var learnProp2 = learnProp1(dictMonadState);
        var resolveProp2 = resolveProp1(dictMonadState);
        return function (dictMonadThrow) {
            var throwError = Control_Monad_Error_Class.throwError(dictMonadThrow);
            var learnProp3 = learnProp2(dictMonadThrow);
            var resolveProp3 = resolveProp2(dictMonadThrow);
            return function (dictMonadWriter) {
                var tellLog2 = tellLog1(dictMonadWriter);
                var learnProp4 = learnProp3(dictMonadWriter);
                var resolveProp4 = resolveProp3(dictMonadWriter);
                return bind(modify(function (v) {
                    return {
                        ripe_rules: v.ripe_rules,
                        known_props: v.known_props,
                        active_props: v.active_props,
                        gas: v.gas - 1 | 0
                    };
                }))(function (v) {
                    return bind(ask)(function (v1) {
                        return discard1(tellLog2({
                            label: "gas = " + show9(v.gas),
                            messages: [  ]
                        }))(function () {
                            return discard1(when(v.gas <= 0)(discard1(tellLog2({
                                label: "error",
                                messages: [ new Data_Tuple.Tuple("reason", Halogen_HTML_Elements.div([  ])(pure(Halogen_HTML_Core.text("out of gas")))), new Data_Tuple.Tuple("initialGas", Halogen_HTML_Elements.div([  ])(pure(Halogen_HTML_Core.text(show9(v1.mod.value0.initialGas))))) ]
                            }))(function () {
                                return throwError({
                                    label: Foliage_Common["_error"],
                                    source: "fixpointFocusModule",
                                    description: "ran out of gas"
                                });
                            })))(function () {
                                if (v.active_props instanceof Data_List_Types.Nil) {
                                    return discard1(tellLog2({
                                        label: "done",
                                        messages: [ new Data_Tuple.Tuple("gas", Halogen_HTML_Elements.div([  ])(pure(Halogen_HTML_Core.text(show9(v.gas))))) ]
                                    }))(function () {
                                        return pure2(Data_Unit.unit);
                                    });
                                };
                                if (v.active_props instanceof Data_List_Types.Cons) {
                                    return discard1(modify_(function (v2) {
                                        return {
                                            gas: v2.gas,
                                            ripe_rules: v2.ripe_rules,
                                            known_props: v2.known_props,
                                            active_props: v.active_props.value1
                                        };
                                    }))(function () {
                                        return discard1(when(v.active_props.value0.isNew)(learnProp4(v.active_props.value0.prop)))(function () {
                                            return discard1(resolveProp4(v.active_props.value0.prop))(function () {
                                                return fixpointFocusModule(dictMonadReader)(dictMonadState)(dictMonadThrow)(dictMonadWriter);
                                            });
                                        });
                                    });
                                };
                                throw new Error("Failed pattern match at Foliage.Interpretation (line 137, column 3 - line 146, column 26): " + [ v.active_props.constructor.name ]);
                            });
                        });
                    });
                });
            };
        };
    };
};
var interpModule = function (dictMonad) {
    var Bind1 = dictMonad.Bind1();
    var discard1 = discard(Bind1);
    var traceM1 = traceM(dictMonad);
    var bind = Control_Bind.bind(Bind1);
    var monadStateT = Control_Monad_State_Trans.monadStateT(dictMonad);
    var fixpointFocusModule1 = fixpointFocusModule(Control_Monad_Except_Trans.monadReaderExceptT(Control_Monad_Reader_Trans.monadReaderReaderT(monadStateT)))(Control_Monad_Except_Trans.monadStateExceptT(Control_Monad_Reader_Trans.monadStateReaderT(Control_Monad_State_Trans.monadStateStateT(dictMonad))))(Control_Monad_Except_Trans.monadThrowExceptT(Control_Monad_Reader_Trans.monadReaderT(monadStateT)));
    var pure2 = Control_Applicative.pure(dictMonad.Applicative0());
    return function (dictMonadWriter) {
        var fixpointFocusModule2 = fixpointFocusModule1(Control_Monad_Except_Trans.monadWriterExceptT(Control_Monad_Reader_Trans.monadWriterReaderT(Control_Monad_State_Trans.monadWriterStateT(dictMonadWriter))));
        return function (dictMonadThrow) {
            return function (v) {
                return discard1(traceM1("[interpModule]"))(function () {
                    var env = (function () {
                        var v1 = lmap(fold2)(partitionEither(function (rule) {
                            return (function (v2) {
                                if (v2 instanceof Data_Either.Left) {
                                    return new Data_Either.Right({
                                        prop: v2.value0,
                                        isNew: false
                                    });
                                };
                                if (v2 instanceof Data_Either.Right) {
                                    return new Data_Either.Left(Data_Map_Internal.singleton(v2.value0.value0.hypothesis.value0.value0)(Data_List.singleton(new Foliage_Program.RipeRule({
                                        hypothesis: v2.value0.value0.hypothesis,
                                        "rule'": v2["value0"]["value0"]["rule'"]
                                    }))));
                                };
                                throw new Error("Failed pattern match at Foliage.Interpretation (line 101, column 25 - line 103, column 195): " + [ v2.constructor.name ]);
                            })(Foliage_Program.nextHypothesis(rule));
                        })(Data_Map_Internal.values(v.value0.rules)));
                        return {
                            gas: v.value0.initialGas,
                            ripe_rules: v1.value0,
                            known_props: foldr(unionWith(append1))(Data_Map_Internal.empty)(map1(function (v2) {
                                return Data_Map_Internal.singleton(v2.prop.value0)(Data_List.singleton(v2.prop));
                            })(v1.value1)),
                            active_props: v1.value1
                        };
                    })();
                    var ctx = {
                        mod: new Foliage_Program.Module(v.value0)
                    };
                    return bind(Data_Function.flip(Control_Monad_State_Trans.runStateT)(env)(Data_Function.flip(Control_Monad_Reader_Trans.runReaderT)(ctx)(Control_Monad_Except_Trans.runExceptT(fixpointFocusModule2))))(function (v1) {
                        return pure2(new Data_Tuple.Tuple(Data_Either.either(Data_Maybe.Just.create)(Data_Function["const"](Data_Maybe.Nothing.value))(v1.value0), v1.value1));
                    });
                });
            };
        };
    };
};
var _Newtype_Env = {
    Coercible0: function () {
        return undefined;
    }
};
var _Newtype_Ctx = {
    Coercible0: function () {
        return undefined;
    }
};
export {
    Ctx,
    Env,
    Log,
    tellLog,
    interpModule,
    fixpointFocusModule,
    askRenderCtx,
    learnProp,
    joinProps,
    insertProp,
    resolveProp,
    deferProp,
    deferRipeRule,
    applyRipeRuleToProp,
    saturateTermSubst,
    processSideHypotheses,
    processSideHypothesis,
    evaluateTerm,
    compareProp,
    compareTerm,
    throwError_compareTerm,
    partitionEither,
    _Newtype_Ctx,
    _Newtype_Env
};
